export default __webpack_public_path__ + "static/media/vuetifyjs.8a22a3ec.svg";